export default __webpack_public_path__ + "static/media/upArrow.81b0ab02.svg";